import {
  BlueprintEntity,
  RELATION_HAS_MAIN_TEMPLATE,
} from '@agilelab/plugin-wb-builder-common';
import { EntityErrorResult } from '@agilelab/plugin-wb-catalog-extension-common';
import { WbFieldLabel, WbTagsArray } from '@agilelab/plugin-wb-platform';
import { RELATION_HAS_PART } from '@mainstage/catalog-model';
import { useRelatedEntities } from '@mainstage/plugin-catalog-react';
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';

import { CSSProperties, useMemo } from 'react';
import { BlueprintCardComponents } from './BlueprintCardComponents';
import { BlueprintCardContent } from './BlueprintCardContent';
import { BlueprintCardFooter } from './BlueprintCardFooter';
import { BlueprintCardHeader } from './BlueprintCardHeader';
import { BlueprintCardWrapper } from './BlueprintCardWrapper';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      flexBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
    }),
  { name: 'blueprintCard' },
);

export const BlueprintCard = (props: {
  blueprint: BlueprintEntity;
  error?: EntityErrorResult;
  style?: CSSProperties;
  className?: string;
  hideFooter?: boolean;
  hideFavourite?: boolean;
}) => {
  const { blueprint, error, style, hideFooter, hideFavourite, className } =
    props;
  const classes = useStyles();

  const { entities: mainTemplate } = useRelatedEntities(blueprint, {
    type: RELATION_HAS_MAIN_TEMPLATE,
  });

  const { entities } = useRelatedEntities(blueprint, {
    type: RELATION_HAS_PART,
    kind: 'Template',
  });

  const templates = useMemo(
    () => (entities && mainTemplate ? [...mainTemplate, ...entities] : []),
    [entities, mainTemplate],
  );

  const tags = blueprint.metadata.tags?.map(tag => ({ tagFQN: tag })) ?? [];

  return (
    <BlueprintCardWrapper className={className} style={style}>
      <BlueprintCardHeader
        blueprint={blueprint}
        error={error}
        hideFavourite={hideFavourite}
      />

      <BlueprintCardContent>
        <Typography>{blueprint.metadata.description}</Typography>

        <BlueprintCardComponents entities={templates} />

        <Box className={classes.flexBox}>
          <WbFieldLabel label="TAGS" />
          {!!tags.length ? (
            <WbTagsArray tags={tags} />
          ) : (
            <Typography>No tags</Typography>
          )}
        </Box>
      </BlueprintCardContent>

      {!hideFooter && (
        <BlueprintCardFooter blueprint={blueprint} error={error} />
      )}
    </BlueprintCardWrapper>
  );
};
